
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/register",
      function () {
        return require("private-next-pages/app/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/register"])
      });
    }
  